import StylesProvider from './StylesProvider';

export default StylesProvider;
